class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      this.closest('.cart-item').style.setProperty('display','none','important');
      cartItems.updateQuantity(this.dataset.index, 0,null,null,this.dataset.bundle);
      setTimeout(()=>{window.freeplaypackthreshold?.checkCart()},1000);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    
    document.addEventListener("la:dn:cart:updated", async function(event) {
        const discountedCart = event.detail.data[0];
        console.log('The cart is updated by Discount Ninja', discountedCart);
        
        // Add delay before updating cart drawer header
        setTimeout(() => {
            try {          
                var price = discountedCart.total.discountedPrice || 0;
                var currency = discountedCart.currency || 'USD';
                console.log('Updating cart drawer header with price and currency:', price, currency);
                document.querySelector('cart-drawer-items').updateCartDrawerHeader(price,currency);
            } catch (error) {
                console.log('Error updating cart drawer header:', error);
            }
        }, 500); // 500ms delay
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  updateCartDrawerHeader(cartPrice = 0,currency = 'USD') {
      const cartDrawer = document.querySelector('cart-drawer');
      console.log('Start Header Drawer Update',!!cartDrawer);
      if (!cartDrawer) return;

      // const cartPrice = cartData.total.discountedPrice || 0;
      const countryCode = cartDrawer.dataset.countryCode;
      const currencySymbol = cartDrawer.dataset.currencySymbol;
      
      // Get free shipping thresholds from data attributes
      const freeShippingPrice = parseInt(cartDrawer.dataset.freeShippingPrice) || 0;
      const freeShippingPriceUk = parseInt(cartDrawer.dataset.freeShippingPriceUk) || 0;
      const freeShippingPriceUs = parseInt(cartDrawer.dataset.freeShippingPriceUs) || 0;
      
      // Get text variables from data attributes
      var  freeShippingUnlocked = cartDrawer.dataset.freeShippingUnlocked;
      const freeShippingAway = cartDrawer.dataset.freeShippingAway;
      var freeShippingAwaySuffix = cartDrawer.dataset.freeShippingAwaySuffix;
      const freeShippingUs = cartDrawer.dataset.freeShippingUs;
      
      let threshold, width;
      const headerNote = document.querySelector('#cart-promo-banner p');
      const progressBar = document.querySelector('.free-sf-bar');
      
      if (!headerNote || !progressBar) return;
      
      // Determine threshold based on country
      if (countryCode === 'uk') {
          threshold = freeShippingPriceUk;
      } else if (countryCode === 'us') {
          threshold = freeShippingPriceUs;
          // freeShippingAwaySuffix = 'AWAY FROM FREE HALLOWEEN GIFT';
          // freeShippingUnlocked = `CONGRATS! YOU'VE UNLOCKED A FREE HALLOWEEN GIFT`;
          // threshold = 8900;
      } else {
          threshold = freeShippingPrice;
      }
      
      // Calculate progress width
      width = Math.min((cartPrice / threshold) * 100, 100);
      // Update header text based on country and cart total
      if (countryCode === 'us' && false) { // Always show free shipping for US
          headerNote.textContent = freeShippingUs;
          headerNote.classList.add('congrats');
          width = 100;
      } else if (cartPrice >= threshold) {
          headerNote.textContent = freeShippingUnlocked;
          headerNote.classList.add('congrats');
      } else {
          const remaining = threshold - cartPrice;
          const formattedAmount = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency,
              minimumFractionDigits: 2
          }).format(remaining / 100);
          
          headerNote.textContent = `${freeShippingAway} ${formattedAmount} ${freeShippingAwaySuffix}`;
          headerNote.classList.remove('congrats');
      }
      
      // Update progress bar
      progressBar.style.width = `${width}%`;
      var promoDiv = document.querySelector('#cart-promo-banner');
      if(promoDiv) promoDiv.style.display = '';
      console.log('Cart drawer header updated successfully',threshold,cartPrice,cartPrice >= threshold);
  }
  onChange(event) {
    if (event.target.dataset.exclude != 1) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    this.updateCartTotalWithoutDiscount();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, bundle) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if(bundle && parsedState.item_count){
          for (const key in parsedState.items) {
            if(typeof parsedState.items[key].properties._customBundle != 'undefined' && parsedState.items[key].properties._customBundle == bundle){
              setTimeout(() => {
                this.updateQuantity(parseInt(key) + 1, 0,null,null,bundle);
              }, 500);
              return;
            }
          }
        }
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        var cartPrice = parsedState.total_price || 0;
        var currency = parsedState.currency || 'USD';
        // this.updateCartDrawerHeader(cartPrice,currency);
      })
      .catch((e) => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.updateCartTotalWithoutDiscount();
        this.disableLoading(line);
        setTimeout(()=>window.freeplaypackthreshold?.checkCart(),500);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus?.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus?.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    var promoDiv = document.querySelector('#cart-promo-banner');
    if(promoDiv) promoDiv.style.display = 'none';
    console.log('enable loading');
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if(mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }    
  }

  updateCartTotalWithoutDiscount() {
    console.log('updateCartTotalWithoutDiscount');    
    fetch(`/cart.js`)
      .then((response) => response.json())
      .then((cartVar) => {
        const cartItems = cartVar.items;
        var total = 0;
        for (const item of cartItems) {
          total += item.presentment_price * item.quantity;
        }
        // add total to cart attribute via post
        const body = JSON.stringify({ attributes: {total_without_discount:total} });
        fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), ...{ body } });
        
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
